import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import BaseComponent from '../base.component';
import { Template } from '../../models/template';
import { HcTableDataSource } from '@healthcatalyst/cashmere';
import { ToastNotificationService } from 'src/app/core/services/toast-notification.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TemplateService } from 'src/app/core/services/application/template.service';

@Component({
    selector: 'cdp-template-list',
    templateUrl: './template-list.component.html',
    styleUrls: ['./template-list.component.scss'],
    standalone: false
})
export class TemplateListComponent extends BaseComponent implements OnInit {
    templateDataSource = new HcTableDataSource<Template>();
    loadingTemplatesFailed: boolean;
    loadingTemplates: boolean;
    form: FormGroup;

    @Output() createSourcesClicked = new EventEmitter<void>();
    @Output() templateChanged = new EventEmitter<Template>();

    constructor(
        private service: TemplateService,
        private toast: ToastNotificationService,
        private fb: FormBuilder
    ) {
        super();
    }
    ngOnInit(): void {
        this.form = this.fb.group({
            templateId: new FormControl()
        });
        this.loadTemplateList();
    }

    loadTemplateList(toastOnError = false) {
        this.loadingTemplates = true;
        this.service
            .getTemplates()
            .pipe(this.unsubscribeOnDestroy())
            .subscribe({
                next: data => {
                    this.templateDataSource = new HcTableDataSource(
                        data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
                    );

                    this.loadingTemplates = false;
                },
                error: () => {
                    this.loadingTemplates = true;
                    if (toastOnError) {
                        this.toast.showError('Contact an admin if the problem continues.', 'Failed to Load Tenants');
                    }
                }
            });
    }

    onCreateSourceFromScratch() {
        this.createSourcesClicked.emit();
    }

    onTemplateClicked() {
        const selectedTemplate = this.templateDataSource.data.filter(
            t => t.templateId === this.form.value.templateId
        )[0];
        this.templateChanged.emit(selectedTemplate);
    }

    search(term: string): void {
        this.templateDataSource.filter = term;
    }

    clear(): void {
        this.form.controls['templateId'].setValue(null);
    }
}
